import { ref } from 'vue'
import { getPolicy } from '@/service/common/common'
import { reverseTimestamp } from '@/utils/date-format'
import type { ElFile, UploadFile } from 'element-plus/lib/el-upload/src/upload.type'
import { ElUpload } from 'element-plus'

export function useUpload() {
  const uploadRef = ref<InstanceType<typeof ElUpload>>()

  const extraData = ref()
  const files = ref<Array<string>>([])
  const action = ref()
  const filesMap = ref<Map<String, String>>(new Map)
  const proveFile = ref<Map<String, String>>(new Map)
  const records = ref<Array<string>>([])
  const beforeUpload = async (file: UploadFile) => {
    const data = await getPolicy()
    const key =
      data.dir +
      reverseTimestamp() +
      file.name.substring(file.name.lastIndexOf('.'))
    extraData.value = {
      ...data,
      OSSAccessKeyId: data.accessId,
      key
    }
    action.value = data.host
    files.value.push(data.host + '/' + key)
    if (file instanceof File) {
      if (file.type.startsWith('audio')) {
        records.value.push(data.host + '/' + key)
      } else {
        filesMap.value.set(String(file.uid), data.host + '/' + key)
      }
    }
  }

  const proveUpload = async (file: UploadFile) => {
    if (file.name != undefined){
      const data = await getPolicy()
      const key =
        data.dir +
        reverseTimestamp() +
        file.name.substring(file.name.lastIndexOf('.'))
      extraData.value = {
        ...data,
        OSSAccessKeyId: data.accessId,
        key
      }
      action.value = data.host
      files.value.push(data.host + '/' + key)
      if (file instanceof File) {
        proveFile.value.set(String(file.uid), data.host + '/' + key)
      }
    }
  }

  const onSuccess = (response: any) => {
    console.log(response)
  }

  const onExceed = (elFiles: ElFile[]) => {
    uploadRef.value?.clearFiles()
    const file = elFiles[0]
    file.uid = Number(reverseTimestamp())
    files.value = []
    uploadRef.value!.handleStart(file)
    uploadRef.value!.submit()
  }

  return [
    uploadRef,
    extraData,
    files,
    action,
    beforeUpload,
    proveUpload,
    onSuccess,
    onExceed,
    filesMap,
    proveFile,
    records
  ]
}
